const motorVehicles = [
  {
    cName: 'AUTOMOBILES, Private Use',
    oSubMenu: [
      {
        cName: '01 Automobile, Private Use, thru 2499 lbs',
        cReturn: '01 Automobile, Private Use, thru 2499 lbs|14.50|14.50|14.50|14.50|14.50|14.50|14.50|14.50|14.50|14.50|14.50|14.50|29.00|29.00|29.00|1|27.60|14.50|1|3|1|01',
      }, {
        // FS320.08(2)c
        cName: '01 Automobile, Private Use, 2500 to 3499 lbs',
        cReturn: '01 Automobile, Private Use, 2500 to 3499 lbs|22.50|22.50|22.50|22.50|22.50|22.50|22.50|22.50|22.50|22.50|22.50|22.50|45.00|45.00|45.00|1|35.60|22.50|1|3|01|01',
      }, {
        // FS320.08(2)d
        cName: '01 Automobile, Private Use, over 3500 lbs',
        cReturn: '01 Automobile, Private Use, over 3500 lbs|32.50|32.50|32.50|32.50|32.50|32.50|32.50|32.50|32.50|32.50|32.50|32.50|65.00|65.00|65.00|1|45.60|32.50|1|3|01|01',
      }, {
        // FS320.08(2)a
        cName: '14 Non-Resident Military, Automobile, Private Use',
        cReturn: '14 Non-Resident Military, Automobile, Private Use|3.00|3.00|3.00|3.00|3.00|3.00|3.00|3.00|3.00|3.00|3.00|3.00|6.00|6.00|6.00|1|2|3.00|2|1|14|14',
      }, {
        cName: '82 Horseless Carriage, Automobile, Private Use',
        cReturn: '82 Horseless Carriage, Automobile, Private Use|7.50|7.50|7.50|7.50|7.50|7.50|7.50|7.50|7.50|7.50|7.50|7.50|15.00|15.00|15.00|1|20.60|7.50|2|2|82|82',
      }, // FS320.08(2)a
      {
        cName: '95 Antique Passenger Cars (with Antique Plate)',
        cReturn: '95 Antique Passenger Cars (with Antique Plate)|7.50|7.50|7.50|7.50|7.50|7.50|7.50|7.50|7.50|7.50|7.50|7.50|15.00|15.00|15.00|1|20.60|7.50|2|1|95|95',
      },
    ], // FS320.08(2)a
  }, {
    cName: 'PICKUPS / TRUCKS',
    oSubMenu: [
      {   // FS320.08(3)a
        cName: '14 Non-Resident Military, Truck / Pickup thru 7999 lbs, Private Use',
        cReturn: '14 Non-Resident Military, Truck / Pickup thru 7999 lbs, Private Use|3.00|3.00|3.00|3.00|3.00|3.00|3.00|3.00|3.00|3.00|3.00|3.00|6.00|6.00|6.00|1|2|3.00|2|1|14|14',
      }, {
        cName: '31 Truck / Pickup thru 1999 lbs',
        cReturn: '31 Truck / Pickup thru 1999 lbs|14.50|14.50|14.50|14.50|14.50|14.50|14.50|14.50|14.50|14.50|14.50|14.50|29.00|29.00|29.00|1|27.60|19.50|1|3|31|31',
      }, // FS320.08(3)a
      {
        cName: '31 Truck / Pickup 2000 to 3000 lbs',
        cReturn: '31 Truck / Pickup 2000 to 3000 lbs|22.50|22.50|22.50|22.50|22.50|22.50|22.50|22.50|22.50|22.50|22.50|22.50|45.00|45.00|45.00|1|35.60|30.50|1|3|31|31',
      }, // FS320.08(3)b
      {
        cName: '31 Truck / Pickup 3001 to 5000 lbs',
        cReturn: '31 Truck / Pickup 3001 to 5000 lbs|32.50|32.50|32.50|32.50|32.50|32.50|32.50|32.50|32.50|32.50|32.50|32.50|65.00|65.00|65.00|1|45.60|44.00|1|3|31|31',
      }, // FS320.08(3)c
      {
        cName: '41 Trucks over 5,000lb, see Heavy Truck listing',
        bEnabled: false,
        cReturn: '0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|41',
      },
      {
        cName: '42 Chassis Mount Camper, unit affixed to truck chassis, thru 4499 lbs',
        cReturn: '42 Chassis Mount Camper, unit affixed to truck chassis, thru 4499 lbs|27.00|27.00|27.00|27.00|27.00|27.00|27.00|27.00|27.00|27.00|27.00|27.00|54.00|54.00|54.00|1|38.60|27.00|1|3|42|42',
      }, // FS320.08(9)d1
      {
        cName: '42 Chassis Mount Camper, unit affixed to truck chassis, 4500 lbs and over',
        cReturn: '42 Chassis Mount Camper, unit affixed to truck chassis, 4500 lbs and over|47.25|47.25|47.25|47.25|47.25|47.25|47.25|47.25|47.25|47.25|47.25|47.25|94.50|94.50|94.50|1|58.85|47.25|1|3|42|42',
      }, // FS320.08(9)d2
      {
        cName: '42 Motor home thru 4499 lbs',
        cReturn: '42 Motor home thru 4499 lbs|27.00|27.00|27.00|27.00|27.00|27.00|27.00|27.00|27.00|27.00|27.00|27.00|54.00|54.00|54.00|1|38.60|27.00|1|3|42|42',
      }, // FS320.08(9)c1
      {
        cName: '42 Motor home, 4500 lbs and over',
        cReturn: '42 Motor home, 4500 lbs and over|47.25|47.25|47.25|47.25|47.25|47.25|47.25|47.25|47.25|47.25|47.25|47.25|94.50|94.50|94.50|1|58.85|47.25|1|3|42|42',
      }, // FS320.08(9)c2
      {
        cName: '42 Private Motor Coach, thru 4499 lbs',
        cReturn: '42 Private Motor Coach, thru 4499 lbs|27.00|27.00|27.00|27.00|27.00|27.00|27.00|27.00|27.00|27.00|27.00|27.00|54.00|54.00|54.00|1|38.60|27.00|2|3|42|42',
      }, // FS320.08(9)e1
      {
        cName: '42 Private Motor Coach, 4500 lbs and over',
        cReturn: '42 Private Motor Coach, 4500 lbs and over|47.25|47.25|47.25|47.25|47.25|47.25|47.25|47.25|47.25|47.25|47.25|47.25|94.50|94.50|94.50|1|58.85|47.25|2|3|42|42',
      }, // FS320.08(9)e1
      {
        cName: '91 Antique Truck < 5000 lbs net Weight /Military Trailer',
        cReturn: '91 Antique Truck < 5000 lbs net Weight /Military Trailer|5.00|5.00|5.00|5.00|5.00|5.00|5.00|5.00|5.63|6.25|6.88|7.50|8.13|8.75|9.38|1|20.60|10.25|2|1|91|91',
      },
    ], // FS320.08(9)e2
  }, {
    cName: 'MOTORCYCLES and MOPEDS',
    oSubMenu: [{
      cName: '65 Motorcycles',
      cReturn: '65 Motorcycles|5.00|5.00|5.00|5.00|5.00|5.00|10.00|10.00|10.00|10.00|10.00|10.00|12.50|12.50|12.50|1|24.10|10.00|2|1|65|65',
    }, // FS320.08(1)a
    {
      cName: '65 Motorcycles Underage',
      cReturn: '65 Motorcycles Underage|5.00|5.00|5.00|5.00|5.00|5.00|10.00|10.00|10.00|10.00|10.00|10.00|12.50|12.50|12.50|1|24.10|10.00|2|1|65|65',
    }, // FS320.08(1)a
    {
      cName: '80 Motorcycles, Antique Plate',
      cReturn: '80 Motorcycles, Antique Plate|5.00|5.00|5.00|5.00|5.00|5.00|7.50|7.50|7.50|7.50|7.50|7.50|9.38|9.38|9.38|1|21.60|13.50|2|1|80|80',
    }, // FS320.08(1)d
    {
      cName: '65 Motorized and Disability Access Vehicle',
      cReturn: '65 Motorized and Disability Access Vehicle|5.00|5.00|5.00|5.00|5.00|5.00|10.00|10.00|10.00|10.00|10.00|10.00|12.50|12.50|12.50|2|24.10|13.50|2|1|65|65',
    }, // FS320.08(1)a DONE
    {
      cName: '80 Motorized and Disability Access Vehicle, Antique Plate',
      cReturn: '80 Motorized and Disability Access Vehicle, Antique Plate|5.00|5.00|5.00|5.00|5.00|5.00|7.50|7.50|7.50|7.50|7.50|7.50|9.38|9.38|9.38|2|21.60|13.50|2|1|80|80',
    }, // FS320.08(1)d
    {
      cName: '69 Mopeds < 2 BrakeHorsePower, pedal-activated motor',
      cReturn: '69 Mopeds < 2 BrakeHorsePower, pedal-activated motor|5.00|5.00|5.00|5.00|5.00|5.00|5.00|5.00|5.00|5.00|5.00|5.00|6.25|6.25|6.25|2|19.10|6.75|2|1|69|69',
    },
    ], // FS320.08(1)b
  }, {
    cName: 'TRAILERS - Flat Fee Types',
    oSubMenu: [{
      cName: '52 Trailers Private Use 500 lbs or less',
      cReturn: '52 Trailers Private Use 500 lbs or less|6.75|6.75|6.75|6.75|6.75|6.75|6.75|6.75|6.75|6.75|6.75|6.75|13.50|13.50|13.50|2|18.35|6.75|2|1|52|52',
    }, // FS320.08(7)a
    {
      cName: "53 Trailers Private Use over 500 lbs, see 'Trailers &gt; 500 & Buses' listing",
      bEnabled: false,
      cReturn: '0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|53',
    },
    {
      cName: '56 Trailer (Semi-Trailer) drawn only by GVW Series truck tractors on 5th wheel, any weight',
      cReturn: '56 Trailer (Semi-Trailer) drawn only by GVW Series truck tractors on 5th wheel, any weight|13.50|13.50|13.50|13.50|13.50|13.50|13.50|13.50|13.50|13.50|13.50|13.50|27.00|27.00|27.00|1|2|13.50|2|2|56|56',
    }, // FS320.08(5)a1 DONE
    {
      cName: '62 Camp trailers, constructed with folding walls',
      cReturn: '62 Camp trailers, constructed with folding walls|13.50|13.50|13.50|13.50|13.50|13.50|13.50|13.50|13.50|13.50|13.50|13.50|27.00|27.00|27.00|1|25.10|13.50|2|3|62|62',
    }, // FS320.08(9)b
    {
      cName: '76 Park Trailer, any length, License plate(TT-PT), not affixed to property',
      cReturn: '76 Park Trailer, any length, License Plate(TT-PT), not affixed to property|6.25|6.25|6.25|12.50|12.50|12.50|25.00|25.00|25.00|25.00|25.00|25.00|31.25|31.25|31.25|4|36.60|25.00|2|2|0|76',
    }, // FS320.08(10)a
    {
      cName: '77 Travel Trailer, (includes 5th wheel), up to 35 ft. (TT-TV)',
      cReturn: '77 Travel Trailer,(includes 5th wheel), up to 35 ft. (TT-TV)|27.00|27.00|27.00|27.00|27.00|27.00|27.00|27.00|27.00|27.00|27.00|27.00|54.00|54.00|54.00|1|38.60|27.00|2|3|77|77',
    }, // FS320.08(9)a
    {
      cName: '78 Travel Trailers over 35, License plate, not affixed to property',
      cReturn: '78 Travel Trailers over 35, License Plate, not affixed to property|6.25|6.25|6.25|12.50|12.50|12.50|25.00|25.00|25.00|25.00|25.00|25.00|31.25|31.25|31.25|1|36.60|25.00|2|2|0|78',
    }, // FS320.08(10)b
    {
      cName: '91 Antique Military Trailer',
      cReturn: '91 Antique Military Trailer|5.00|5.00|5.00|5.00|5.00|5.13|5.98|6.83|7.69|8.54|9.40|10.25|11.10|11.96|12.81|1|23.35|10.25|2|2|91|91',
    }, // FS320.08(3)e
    {
      cName: '103 Permanent Semi-Trailer (drawn only by GVW Series truck tractors on 5th wheel, any weight)',
      cReturn: '103 Permanent Semi-Trailer (drawn only by GVW Series truck tractors on 5th wheel, any weight)|68.00|68.00|68.00|68.00|68.00|68.00|68.00|68.00|68.00|68.00|68.00|68.00|136.00|136.00|136.00|1|2|68.00|2|2|103|103',
    },
    ], // FS320.08(5)a1
  }, {
    cName: 'OTHER VEHICLE TYPES',
    oSubMenu: [{
      cName: '70 Transporter Plate',
      cReturn: '70 Transporter Plate|101.25|101.25|101.25|101.25|101.25|101.25|101.25|101.25|101.25|101.25|101.25|101.25|202.50|202.50|202.50|2|2|101.25|2|2|70|70',
    }, // FS320.08(15)

    // Check dealer plates - 27.00 fees
    {
      cName: '71 Dealer Type Plates (VI, VF, MC, & Trailer Coach) +$27 Use Tax',
      cReturn: '71 Dealer Type Plates (VI, VF, MC, & Trailer Coach) +$27 Use Tax|5.00|5.00|5.00|8.50|8.50|8.50|17.00|17.00|17.00|17.00|178.00|17.00|21.25|21.25|21.25|2|2|17.00|2|2|71|71',
    }, // FS320.08(12) DONE  //27 calculated by _class in SVCfee()
    {
      cName: '74 Dealer Type Plates (Marine Boat Trailer) +$27 Use Tax',
      cReturn: '74 Dealer Type Plates (Marine Boat Trailer) +$27 Use Tax|5.00|5.00|5.00|8.50|8.50|8.50|17.00|17.00|17.00|17.00|178.00|17.00|21.25|21.25|21.25|2|2|17.00|2|2|74|74',
    }, // FS320.08(12) DONE

    // check _class 92
    {
      cName: '92 Hearses, Ambulances',
      cReturn: '92 Hearses, Ambulances|10.13|10.13|10.13|20.25|20.25|20.25|40.50|40.50|40.50|40.50|40.50|40.50|50.63|50.63|50.63|1|2|40.50|2|2|92|92',
    }, // FS320.08(5)2c & // FS320.08(5)f  DONE
    {
      cName: '92 School Buses, exclusive transport pupils in home county (not _class 96)',
      cReturn: '92 School Buses, exclusive transport pupils in home county (not _class 96)|10.25|10.25|10.25|20.50|20.50|20.50|41.00|41.00|41.00|41.00|41.00|41.00|51.25|51.25|51.25|1|2|40.50|2|2|92|92',
    }, // FS320.08(5)2c & // FS320.08(5)f  DONE
    {
      cName: '92 Wreckers (restricted use, disabled,recovered,impounded,replacement)',
      cReturn: '92 Wreckers (restricted use, disabled, recovered, impounded, replacement)|10.25|10.25|10.25|20.50|20.50|20.50|41.00|41.00|41.00|41.00|41.00|41.00|51.25|51.25|51.25|1|2|41.00|2|2|92|92',
    }, // FS320.08(5)d DONE

    {
      cName: '41 Wreckers NOT restricted use, Any tow, see Heavy Truck listing',
      bEnabled: false,
      cReturn: '0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|41',
    },
    {
      cName: '94 TractorCranes, PowerShovels, Well Drillers, Tools with no hauling allowed. Restricted use, cannot carry a load or haul a trailer',
      cReturn: '94 TractorCranes, PowerShovels, Well Drillers, Tools with no hauling allowed. Restricted use, cannot carry a load or haul a trailer|11.00|11.00|11.00|22.00|22.00|22.00|44.00|44.00|44.00|44.00|44.00|44.00|55.00|55.00|55.00|1|2|44.00|2|2|94|94',
    }, // FS320.08(5)b
    {
      cName: '37 Exempt Disabled Veteran License Plate',
      cReturn: '37 Exempt Disabled Veteran License Plate|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|1|4.00|0.00|2|1|37|37',
    }, // FS320.08(4) --- changing 2 to 1 in third spot from end in pipe to allow specialty plates  to be chosen
    {
      cName: '85 Exempt Disabled Veteran Wheelchair License Plate',
      cReturn: '85 Exempt Disabled Veteran Wheelchair License Plate|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|1|4.00|0.00|2|2|85|85',
    }, // FS320.08(4)
    {
      cName: '96 Boy Scouts, Churches, other specific non-profit',
      cReturn: '96 Boy Scouts, Churches, other specific non-profit|3.00|3.00|3.00|3.00|3.00|3.00|3.00|3.00|3.00|3.00|3.00|3.00|6.00|6.00|6.00|1|2|3.00|2|2|96|96',
    }, // FS320.08(13) or // FS320.10(1)a ?
    {
      cName: '97 Exempt Government Vehicle License Plates',
      cReturn: '97 Exempt Government Vehicle License Plates|3.00|3.00|3.00|3.00|3.00|3.00|3.00|3.00|3.00|3.00|3.00|3.00|6.00|6.00|6.00|1|2|3.00|2|2|97|97',
    },
    ], // FS320.08(13), FS320.08(5)b or FS320.08(13) ?
  }];

module.exports = motorVehicles;
